module.exports = __webpack_public_path__ + "static/media/vitalcash.554f87ee.png";